import { VideoModal } from '../components/video_modal.js';

export class NodePageClinicalService extends DrupalBehavior {
  onContent(context) {
    function sidebarNav(e) {
      if (e.matches) {
        $(
          '.interior-main-article--sidebar nav h2, .in-this-section h2',
          context
        ).on('click', function () {
          const $this = $(this);
          $this.toggleClass('open');
          const sidebarNav = $this
            .closest('nav')
            .find('.sidebar-nav--content')[0];
          if ($(this).hasClass('open')) {
            gsap.to(sidebarNav, {
              duration: 0.5,
              ease: 'power4.out',
              height: 'auto',
            });
          } else {
            gsap.to(sidebarNav, {
              duration: 0.5,
              ease: 'power4.out',
              height: 0,
            });
          }
        });
      }
    }

    function accreditationsSlider(context) {
      $('.accreditations', context).slick({
        dots: true,
        slidesToShow: 1,
        speed: 500,
        draggable: true,
        fade: false,
        arrows: false,
        adaptiveHeight: true,
      });
    }

    let mql = window.matchMedia('(max-width: 991px)');
    mql.addEventListener('change', sidebarNav);
    sidebarNav(mql);

    accreditationsSlider(context);

    var videoModal = new VideoModal();
    var videos = context.querySelectorAll('.article--teaser--video');
    videoModal.init(videos);
  }
}

DrupalBehavior.register(
  'rush_theme.node_page',
  'clinical_service',
  NodePageClinicalService
);
